import { FC } from 'react'

import { config } from 'config'
import { SocialNetwork } from 'models'
import { IconOdnoklassniki } from 'components/icons/odnoklassniki'
import { IconFacebook } from 'components/icons/facebook'
import { IconYoutube } from 'components/icons/youtube'
import { IconInstagram } from 'components/icons/instagram'
import { Container } from 'components/container'
import {
  About,
  Authors,
  Copyright,
  Heading,
  Social,
  SocialLinks,
  StyledFooter,
} from './styled'
import { useDataContext } from 'context/data-context'
import { useLocale } from 'locale'

type Props = {}

const socialConfig = {
  facebook: {
    icon: <IconFacebook />,
    linkTj: 'https://www.facebook.com/radio.ozodi', //''https://www.facebook.com/azattyq',
    linkRu: 'https://www.facebook.com/radio.ozodi', //''https://www.facebook.com/RadioAzattyq',
    newTab: true,
  },
  /*vkontakte: {
    icon: <IconVk />,
    linkTj: 'https://vk.com/azattyqradiosy',
    linkRu: 'ttps://vk.com/radioazattyq',
    newTab: true,
  },*/
  odnoklassniki: {
    icon: <IconOdnoklassniki />,
    linkTj: 'https://ok.ru/radioiozodi',
    linkRu: 'https://ok.ru/radioiozodi',
    newTab: true,
  },
  // twitter: { icon: <IconTwitter />, newTab: true },
  instagram: {
    icon: <IconInstagram />,
    linkTj: 'https://www.instagram.com/radioiozodi/', //''https://www.instagram.com/azattyq/',
    linkRu: 'https://www.instagram.com/radioiozodi/', //'https://www.instagram.com/azattyq/',
    newTab: true,
  },
  /*telegram: {
    icon: <IconTelegram />,
    linkTj: 'https://t.me/azattyq',
    linkRu: 'https://t.me/RadioAzattyq',
    newTab: true,
  },*/
  youtube: {
    icon: <IconYoutube />,
    linkTj: 'https://www.youtube.com/user/Ozodivideo', //https://www.youtube.com/user/AzattyqRadio',
    linkRu: 'https://www.youtube.com/user/Ozodivideo', //'https://www.youtube.com/user/AzattyqRadio',
    newTab: true,
  },
  // rss: { icon: <IconRss />, newTab: false },
}

const parseSocial = (appLocale: typeof config.locale) => (
  <SocialLinks>
    {(Object.keys(socialConfig) as SocialNetwork[]).map(k => {
      const networkConfig = socialConfig[k]

      return networkConfig ? (
        <li key={k}>
          <a
            href={
              appLocale === 'tj' ? networkConfig.linkTj : networkConfig.linkRu
            }
            {...(networkConfig.newTab ? { target: '_blank' } : null)}
          >
            {networkConfig.icon}
          </a>
        </li>
      ) : null
    })}
  </SocialLinks>
)

export const Footer: FC<Props> = () => {
  const { appLocale } = useDataContext()
  const locale = useLocale()

  return (
    <StyledFooter>
      <Container>
        <Authors>
          <Heading>{locale.footer.creatorsTitle}</Heading>
          {locale.footer.creators}
        </Authors>
        <Social>
          <Heading>{locale.footer.followUs}</Heading>
          {parseSocial(appLocale)}
        </Social>
        <About>
          <Heading>{locale.footer.contentTitle}</Heading>
          <p>{locale.footer.content}</p>
        </About>
        <Copyright>{locale.footer.copyright}</Copyright>
      </Container>
    </StyledFooter>
  )
}
